import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import Navbar from './Navbar';
import HomePage from './HomePage';
import PrivacyPolicyPage from './PrivacyPolicy';
import { Helmet } from 'react-helmet';
import './App.css';
import Footer from "./Footer";

const App = () => {
    return (
        <>
            <Helmet>
                <title>AI Chef - AI Kitchen Magic: Recipes from Ideas & Ingredients</title>
                <meta name="description" content="Discover the future of cooking with our AI-powered app. Effortlessly create recipes from the ingredients you have or your culinary ideas. Whether you're snapping pics of your pantry or entering your latest food inspiration, our app crafts personalized, delicious recipes just for you. " />

                {/* Open Graph / Facebook */}
                <meta property="og:url" content="https://oeppe.com/aichef" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="AI Chef - AI Kitchen Magic: Recipes from Ideas & Ingredients" />
                <meta property="og:description" content="Discover the future of cooking with our AI-powered app. Effortlessly create recipes from the ingredients you have or your culinary ideas. Whether you're snapping pics of your pantry or entering your latest food inspiration, our app crafts personalized, delicious recipes just for you. " />
                <meta property="og:image" content="https://oeppe.com/aichef/assets/ai_chef_preview.png" />

                {/*/!* Twitter *!/*/}
                {/*<meta name="twitter:card" content="summary_large_image" />*/}
                {/*<meta name="twitter:creator" content="@deinTwitterHandle" />*/}
                {/*<meta name="twitter:title" content="Meine großartige Website" />*/}
                {/*<meta name="twitter:description" content="Eine kurze Beschreibung deiner Seite." />*/}
                {/*<meta name="twitter:image" content="https://www.deine-website.de/path/zum/bild.jpg" />*/}
            </Helmet>
            <div className={'App'}>
                <Router basename="/aichef">
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                        <Route path="*" element={<Navigate replace to="/" />} />
                    </Routes>
                </Router>
                <Footer />
            </div>
        </>
    );
};

export default App;
